/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  InvitationSource,
  PotentialInviteChild,
  PotentialInviteChildFromJSON,
  PotentialInviteChildToJSON,
  PotentialInvitePreviousProgram,
  PotentialInvitePreviousProgramFromJSON,
  PotentialInvitePreviousProgramToJSON,
  PotentialInviteStatus,
} from './'

/**
 * A single potential invite for a community, representing either a returning family or a LCD referral.
 * @export
 * @interface PotentialInviteItem
 */
export interface PotentialInviteItem {
  /**
   * Unique identifier for the potential invite.
   * @type number
   * @memberof PotentialInviteItem
   */
  potentialInviteKey: number
  /**
   * The family's last name.
   * @type string
   * @memberof PotentialInviteItem
   */
  familyName: string
  /**
   * First name of the primary parent contact.
   * @type string
   * @memberof PotentialInviteItem
   */
  parentFirstName: string
  /**
   * Last name of the primary parent contact.
   * @type string
   * @memberof PotentialInviteItem
   */
  parentLastName: string
  /**
   *
   * @type InvitationSource
   * @memberof PotentialInviteItem
   */
  source: InvitationSource
  /**
   *
   * @type PotentialInviteStatus
   * @memberof PotentialInviteItem
   */
  status: PotentialInviteStatus
  /**
   * Contact email. Masked for Returning Families (e.g. ja*********@example.com), full email for LCD Referrals.
   * @type string
   * @memberof PotentialInviteItem
   */
  contactEmail: string
  /**
   * City, State location of the family
   * @type string
   * @memberof PotentialInviteItem
   */
  location?: string
  /**
   * Contact phone number.
   * @type string
   * @memberof PotentialInviteItem
   */
  contactPhone?: string
  /**
   * The children associated with this potential invite.
   * @type {Array<PotentialInviteChild>}
   * @memberof PotentialInviteItem
   */
  children: Array<PotentialInviteChild>
  /**
   * The user key of the parent associated with this returning family. Only present for Returning Families.
   * @type number
   * @memberof PotentialInviteItem
   */
  parentUserKey?: number
  /**
   * Previous program enrollments with suggested next program types. Only present for Returning Families.
   * @type {Array<PotentialInvitePreviousProgram>}
   * @memberof PotentialInviteItem
   */
  previousPrograms?: Array<PotentialInvitePreviousProgram>
  /**
   * The date the LCD referral was created. Only present for LCD Referrals.
   * @type Date
   * @memberof PotentialInviteItem
   */
  referredOn?: Date
  /**
   * Note attached to the LCD referral. Only present for LCD Referrals.
   * @type string
   * @memberof PotentialInviteItem
   */
  referralNote?: string
  /**
   * CRM email addresses associated with the LCD referral. Only present for LCD Referrals.
   * @type {Array<string>}
   * @memberof PotentialInviteItem
   */
  crmEmails?: Array<string>
}

export function PotentialInviteItemFromJSON(json: any): PotentialInviteItem {
  return PotentialInviteItemFromJSONTyped(json, false)
}

export function PotentialInviteItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PotentialInviteItem {
  if (json === undefined || json === null) {
    return json
  }
  return {
    potentialInviteKey: json['potentialInviteKey'],
    familyName: json['familyName'],
    parentFirstName: json['parentFirstName'],
    parentLastName: json['parentLastName'],
    source: json['source'],
    status: json['status'],
    contactEmail: json['contactEmail'],
    location: !exists(json, 'location') ? undefined : json['location'],
    contactPhone: !exists(json, 'contactPhone')
      ? undefined
      : json['contactPhone'],
    children: (json['children'] as Array<any>).map(
      PotentialInviteChildFromJSON
    ),
    parentUserKey: !exists(json, 'parentUserKey')
      ? undefined
      : json['parentUserKey'],
    previousPrograms: !exists(json, 'previousPrograms')
      ? undefined
      : (json['previousPrograms'] as Array<any>).map(
          PotentialInvitePreviousProgramFromJSON
        ),
    referredOn: !exists(json, 'referredOn')
      ? undefined
      : new Date(json['referredOn']),
    referralNote: !exists(json, 'referralNote')
      ? undefined
      : json['referralNote'],
    crmEmails: !exists(json, 'crmEmails') ? undefined : json['crmEmails'],
  }
}

export function PotentialInviteItemToJSON(
  value?: PotentialInviteItem | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    potentialInviteKey: value.potentialInviteKey,
    familyName: value.familyName,
    parentFirstName: value.parentFirstName,
    parentLastName: value.parentLastName,
    source: value.source,
    status: value.status,
    contactEmail: value.contactEmail,
    location: value.location,
    contactPhone: value.contactPhone,
    children: (value.children as Array<any>).map(PotentialInviteChildToJSON),
    parentUserKey: value.parentUserKey,
    previousPrograms:
      value.previousPrograms === undefined
        ? undefined
        : (value.previousPrograms as Array<any>).map(
            PotentialInvitePreviousProgramToJSON
          ),
    referredOn:
      value.referredOn === undefined
        ? undefined
        : value.referredOn.toISOString().substr(0, 10),
    referralNote: value.referralNote,
    crmEmails: value.crmEmails,
  }
}
